import classNames from "classnames";
import { forwardRef, InputHTMLAttributes } from "react";

interface FieldProp extends InputHTMLAttributes<HTMLInputElement> {
  placeholder: string;
}

const Field = forwardRef<HTMLInputElement, FieldProp>(function Field({
  placeholder,
  onChange,
  value,
  type,
  className,
  ...inputProps
}, ref) {
  return (
    <div className="form-control">
      <input
        {...inputProps}
        ref={ref}
        type={type}
        placeholder={placeholder}
        aria-label={inputProps["aria-labelledby"] ? undefined : inputProps["aria-label"] || placeholder}
        autoComplete={inputProps.autoComplete ?? (type === "email" ? "email" : undefined)}
        onChange={onChange}
        value={value}
        className={classNames("field", className)}
      />
    </div>
  );
});

export default Field;
